import React, { useState } from "react";
import NumberFormat from "react-number-format";
import { Button } from "antd";
import { inputClearIcon } from "../../lib/icons";

interface IInputNumberFormat {
  value?: number | string;
  thousandSeparator?: string;
  decimalScale?: number;
  allowNegative?: boolean;
  fixedDecimalScale?: boolean;
  decimalSeparator?: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
  onPressEnter?: () => void;
  allowClear?: boolean;
  className?: string;
  style?: { [key: string]: string };
  placeholder?: string;
}

const InputNumberFormat: React.FC<IInputNumberFormat> = ({
  value,
  thousandSeparator = " ",
  decimalScale = 2,
  allowNegative = true,
  fixedDecimalScale = true,
  decimalSeparator = ".",
  disabled = false,
  onChange = () => {},
  onPressEnter = () => {},
  allowClear = false,
  className = "",
  style = {},
  placeholder,
}) => {
  const [inputValue, setInputValue] = useState(value);

  const handleKeyPress = (e: React.KeyboardEvent): void => {
    if (e.key === "Enter") {
      onPressEnter();
    }
  };

  const handleChange = ({ value: inputNumber }, { source }) => {
    if (source === "prop") return;
    setInputValue(inputNumber);
    onChange(inputNumber);
  };

  const handleClear = () => {
    setInputValue("");
    onChange("");
  };

  const customClassName = `ant-input-affix-wrapper inputNumber__hideArrows ${className}`;

  return (
    <>
      <NumberFormat
        value={value}
        thousandSeparator={thousandSeparator}
        decimalScale={decimalScale}
        allowNegative={allowNegative}
        fixedDecimalScale={fixedDecimalScale}
        decimalSeparator={decimalSeparator}
        isNumericString
        onValueChange={handleChange}
        disabled={disabled}
        className={customClassName}
        style={{ ...style, paddingRight: "27px" }}
        onKeyPress={handleKeyPress}
        placeholder={placeholder}
      />
      {allowClear && inputValue && (
        <Button
          className="button-icon"
          icon={inputClearIcon()}
          onClick={handleClear}
          htmlType="button"
          style={{
            position: "relative",
            zIndex: 10,
            marginLeft: "-35px",
          }}
        />
      )}
    </>
  );
};

export default InputNumberFormat;
